import { render, staticRenderFns } from "./ClientPackageExport.vue?vue&type=template&id=7aef6450"
import script from "./ClientPackageExport.vue?vue&type=script&lang=js"
export * from "./ClientPackageExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports